import { useLazyQuery } from "@apollo/client";
import { ORDERS_SEARCH } from "components/gql/gql_queries_export";
import { GetAlertData } from "contexts/AlertContext";
import { GetData } from "contexts/DataContext";
import {
  consoleBeauty,
  isIdentical,
  isObjectEmpty,
  logGQLError,
} from "data/functions";

export function GetOrdersQuery() {
  const queryName = "SearchOrders";
  const { setAlert } = GetAlertData();
  const { dataObj, forceSetDataObj } = GetData();
  const [refetch, variables] = useLazyQuery(ORDERS_SEARCH, {
    fetchPolicy: "no-cache",
    // notifyOnNetworkStatusChange: true,

    onCompleted: (data) => {
      let res = data?.export_ordersSearch;
      if (isObjectEmpty(res)) {
        setAlert("Документы для оплаты не найдены", "info");
        forceSetDataObj([], "searchDocs");
      } else if (!isIdentical(res, dataObj?.searchDocs)) {
        consoleBeauty("Результаты поиска получены:", "GraphQL", "darkgreen");
        consoleBeauty(res, typeof res, "darkgreen");
        forceSetDataObj(res, "searchDocs");
      }
    },
    onError: (e) => {
      setAlert("Не удалось выполнить поиск", "error");
      logGQLError(queryName, e);
    },
  });
  return [refetch, variables];
}
